//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

import { AreaChart } from '@components/charts/AreaChart';
import { InstagramSummaryTrackingIds } from '@instagram-account/components/summary/instagramSummaryTrackingIds';

export enum SUMMARY_TREND_VALUES {
  ENGAGEMENT_RATE = 'engagementRate',
  FOLLOWERS = 'followerCount',
  CHANGE_IN_FOLLOWERS = 'changeInFollowers',
  NEW_FOLLOWERS_DAY = 'followerCountDay',
  POSTS = 'photoCount',
  NEW_POSTS = 'newPosts',
  LIKES = 'likeCount',
  NEW_LIKES = 'newLikeCount',
  COMMENTS = 'commentCount',
  NEW_COMMENTS = 'newCommentCount',
  IMPRESSIONS = 'impressionCount',
  ACCOUNT_REACH = 'reach',
  ACCOUNT_REACH_DAY = 'reachDay',
  REVENUE = 'revenue',
  TRANSACTIONS = 'transactions',
  TRAFFIC = 'traffic',
}

export const SUMMARY_TREND_VALUE_LABELS = {
  [SUMMARY_TREND_VALUES.ENGAGEMENT_RATE]: 'Total Eng. Rate',
  [SUMMARY_TREND_VALUES.FOLLOWERS]: 'Followers',
  [SUMMARY_TREND_VALUES.CHANGE_IN_FOLLOWERS]: 'Change in Followers',
  [SUMMARY_TREND_VALUES.NEW_FOLLOWERS_DAY]: 'New Followers',
  [SUMMARY_TREND_VALUES.POSTS]: 'Posts',
  [SUMMARY_TREND_VALUES.NEW_POSTS]: 'New Posts',
  [SUMMARY_TREND_VALUES.LIKES]: 'Total Likes',
  [SUMMARY_TREND_VALUES.NEW_LIKES]: 'New Likes',
  [SUMMARY_TREND_VALUES.COMMENTS]: 'Total Comments',
  [SUMMARY_TREND_VALUES.NEW_COMMENTS]: 'New Comments',
  [SUMMARY_TREND_VALUES.IMPRESSIONS]: 'Impressions',
  [SUMMARY_TREND_VALUES.ACCOUNT_REACH]: 'Account Reach',
  [SUMMARY_TREND_VALUES.ACCOUNT_REACH_DAY]: 'Account Reach',
  [SUMMARY_TREND_VALUES.REVENUE]: 'Revenue',
  [SUMMARY_TREND_VALUES.TRANSACTIONS]: 'Transactions',
  [SUMMARY_TREND_VALUES.TRAFFIC]: 'Site Visits',
};

export const INSTAGRAM_ACCOUNT_SUMMARY_TRENDS_CHART_HEIGHT = 260;
export const INSTAGRAM_ACCOUNT_SUMMARY_TRENDS_CHART_WIDTH = 670;

export const AllSummaryTrendsDropdownOptions = [
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.CHANGE_IN_FOLLOWERS],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-change-in-followers`,
    value: SUMMARY_TREND_VALUES.CHANGE_IN_FOLLOWERS,
  },
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.ACCOUNT_REACH],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-account-reach`,
    value: SUMMARY_TREND_VALUES.ACCOUNT_REACH_DAY,
  },
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.ENGAGEMENT_RATE],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-engagement-rate`,
    value: SUMMARY_TREND_VALUES.ENGAGEMENT_RATE,
  },
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.REVENUE],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-revenue`,
    value: SUMMARY_TREND_VALUES.REVENUE,
  },
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.TRAFFIC],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-traffic`,
    value: SUMMARY_TREND_VALUES.TRAFFIC,
  },
  {
    label: SUMMARY_TREND_VALUE_LABELS[SUMMARY_TREND_VALUES.TRANSACTIONS],
    trackingId: `${InstagramSummaryTrackingIds.SUMMARY_TRENDS_DROPDOWN}-transactions`,
    value: SUMMARY_TREND_VALUES.TRANSACTIONS,
  },
];

export const BASE_CHART_OPTIONS: Pick<
  React.ComponentPropsWithoutRef<typeof AreaChart>,
  'customOptions'
> = {
  customOptions: {
    chart: {
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
      height: INSTAGRAM_ACCOUNT_SUMMARY_TRENDS_CHART_HEIGHT,
      width: INSTAGRAM_ACCOUNT_SUMMARY_TRENDS_CHART_WIDTH,
    },
    series: [
      {
        color: theme.colors.blue2,
        turboThreshold: 0,
        type: 'area',
      },
    ],
  },
};
